import { FilterProps } from "../../../../types";
import { StatusFilter } from "./components/statusFilter/StatusFilter";
import { FiltersContainer } from "../../../../../dashboard/reports/components/table/utils/styled";
import { makeStyles } from '@mui/styles';
import { Box } from "@mui/material";
import colors from "../../../../../../common/styles/colors";
import { CustomerTypeFilter } from "./components/customerTypeFilter/CustomerTypeFilter";
import { BadgeProductFilter } from "./components/badgeProductFilter/BadgeProductFilter";
import { PaymentStatusFilter } from "./components/paymentStatusFilter/PaymentStatusFilter";

type Props = Omit<FilterProps, 'config' | 'filterTableData'>;

const useStyles = makeStyles({
  container: {
    backgroundColor: colors.grey['200'],
    padding: '12px 18px'
  }
})

export const ToolbarFilters = ({ filterSetters, filterGetters }: Props) => {
  const classes = useStyles();

  return <Box className={classes.container}>
    <FiltersContainer>
      <StatusFilter filterSetters={filterSetters} filterGetters={filterGetters} />
      <PaymentStatusFilter filterSetters={filterSetters} filterGetters={filterGetters} />
      <CustomerTypeFilter filterSetters={filterSetters} filterGetters={filterGetters} />
      <BadgeProductFilter filterSetters={filterSetters} filterGetters={filterGetters} />
    </FiltersContainer>
  </Box>;
}
